




















































import { Component, Vue } from "vue-property-decorator";
import { settlementOperation } from "@/req/settlement";
@Component({
  components: {},
})
export default class Home extends Vue {
  public modelShow = false;
  public ids = "";
  public state = 1;
  public content = "";
  public show(state, ids) {
    this.state = state;
    this.ids = "";
    this.ids = ids;
    this.content = "";
    this.modelShow = true;
  }
  public async submit() {
    const res = await settlementOperation({
      token: this.$fn.cookies.getToken("token"),
      type: this.state == 3 ? 2 : 1,
      ids: this.ids,
      remark: this.content,
    });
    if (res.code == 0) {
      this.$Message.success(res.msg);
      this.$emit("getList", this.state);
      this.modelShow = false;
    }
  }
}
